<script setup lang="ts">
import { computed } from 'vue';

import VDialog from '@components/dialogs/VDialog/VDialog.vue';

import type {
  MerchantLogoPreviewEmits,
  MerchantLogoPreviewProps,
} from './types';

const props = defineProps<MerchantLogoPreviewProps>();
const emit = defineEmits<MerchantLogoPreviewEmits>();

const isVisible = computed(() => !!props.logoUrl);
</script>

<template>
  <VDialog
    :visible="isVisible"
    :title="title"
    @hide="emit('hide')"
  >
    <div class="flex justify-center">
      <div class="flex h-24 w-sidebar-width items-center justify-center overflow-hidden">
        <img
          :src="logoUrl"
          :alt="`${title} logo`"
          class="m-auto max-h-full max-w-full"
        >
      </div>
    </div>
  </VDialog>
</template>
